import React from 'react';
import { Stack, Typography } from '@mui/material';
import { Star } from 'react-feather';
import { PVBlack } from '@pv/common/colors';

interface VenueRatingProps {
  rating?: number;
  reviewCount?: number;
}

export const VenueRating: React.FC<VenueRatingProps> = ({ rating, reviewCount }) => {
  if (!rating || !reviewCount) {
    return null;
  }

  return (
    <Stack direction="row" alignItems="center" gap="4px">
      <Star size={16} color={PVBlack} />
      <Typography variant="body2" >
        {rating} ({reviewCount})
      </Typography>
    </Stack>
  );
};
